export * from './error';
export * from './request';
export * from './result';
export * from './variables';
export * from './collectTypenames';
export * from './formatDocument';
export * from './streamUtils';
export * from './operation';

export const noop = () => {
  /* noop */
};
